var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearchActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 4.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m55.465 63.548 11.477 11.477a6.38 6.38 0 0 0 9.029 0 6.38 6.38 0 0 0 0-9.029L63.227 53.247a6.385 6.385 0 0 0-9.034 0l-7.69-7.69",
    stroke: "#4615D6",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.618 28.01c0 14.14-11.467 25.608-25.608 25.608-14.145 0-25.608-11.467-25.608-25.608 0-14.146 11.463-25.608 25.608-25.608 14.141 0 25.608 11.462 25.608 25.608z",
    stroke: "#AC9EE4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchActive);
export default __webpack_public_path__ + "static/media/icon-search-active.ad9af8498752e36619eee6d613c5447d.svg";
export { ForwardRef as ReactComponent };